export default __webpack_public_path__ + "static/media/liskov-logo-michael.8b1a2295.png";